<template>
  <div class="slider">
    <div class="slider__wrapper">
      <div class="slider__slides" :style="`transform:translate3d(${offsetX}px, 0, 0)`">
        <div
          v-for="(slideItem, index) in slides"
          :key="`slide-${index}`"
          ref="slides"
          class="slider__slide"
        >
          <slot
            name="slide"
            :slide="slideItem"
            :slide-index="index"
          >
            <span class="slider__debug">
              Here the slide #{{ index }} content
            </span>
          </slot>
        </div>
      </div>
    </div>

    <div class="slider__nav">
      <div class="slider__prev" @click="goPrev">
        <slot name="previous" :enabled="offsetX < 0">
          <button>previous</button>
        </slot>
      </div>

      <div class="slider__next" @click="goNext">
        <slot name="next" :enabled="offsetX > offsetLimit">
          <button>next</button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>

function getSlideInfos(slides) {
  const list = [];
  let width = 0;
  let accWidth = 0;

  slides.forEach(el => {
    width = el.offsetWidth;
    list.push({ start: accWidth, end: accWidth + width, width, el });
    accWidth += width;
  });

  const first = list[0];
  const last = list[list.length - 1];

  first.isFirst = true;
  last.isLast = true;

  return { list, first, last, width: accWidth };
}

function findNextSlideInfo(infos, offset, width) {
  return infos.find(info => info.end > offset + width);
}

function findPreviousSlideInfo(infos, offset) {
  return infos.reverse().find(info => info.start < offset);
}

export default {
  props: {
    slides: { type: Array, default: () => [] },
  },

  data() {
    return {
      offsetX: 0,
      width: 0,
      offsetLimit: 0,
    };
  },

  watch: {
    width(value) {
      this.offsetLimit = -getSlideInfos(this.$refs.slides).width + value;
    },
  },

  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.updateSize);
    }
    this.updateSize();
  },

  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateSize);
    }
  },

  methods: {
    updateSize() {
      this.$nextTick(() => { this.width = this.$el.offsetWidth });
    },

    goNext() {
      const width = this.$el.offsetWidth;
      const slideInfos = getSlideInfos(this.$refs.slides);
      const limitOffset = -slideInfos.last.end + width;
      const offset = -this.offsetX;
      const target = findNextSlideInfo(slideInfos.list, offset, width);

      if (!target) return;

      if (target.start <= offset) {
        // slide too large display end
        this.offsetX = -target.end + width;
        return;
      }

      this.offsetX = Math.max(-target.start, limitOffset);
    },

    goPrev() {
      const width = this.$el.offsetWidth;
      const slideInfos = getSlideInfos(this.$refs.slides);
      const limitOffset = 0;
      const offset = -this.offsetX;
      const target = findPreviousSlideInfo(slideInfos.list, offset);

      if (!target) return;

      if (target.end - width < offset) {
        // slide too large display start
        this.offsetX = Math.min(-target.end + width, limitOffset);
        return;
      }

      this.offsetX = Math.min(-target.start, limitOffset);
    },
  },
};
</script>

<style lang="stylus" scoped>
.slider {
  position relative
}

.slider__wrapper {
}

.slider__slides {
  display flex
  justify-content flex-start
  transition transform 0.35s ease-out
}

.slider__slide {
  flex 1 0 auto
}

.slider__nav {
  position absolute
  top 0
  right 0
  display flex
}

.slider__debug {
  display inline-block
  box-sizing border-box
  padding 20px
  border 1px solid #F5F5F5
}
</style>
